import React from 'react'
import GatsbyImage from 'gatsby-image'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { getThemeColor } from '@/utils/themes'
import { rem } from '@/utils/helpers'
import Typography from '@/components/common/Typography'

const Template = props => {
  const { theme, icon, title, desc, ...others } = props
  return (
    <Root theme={theme} {...others}>
      <Icon fluid={icon} />
      <Title theme={theme} variant="h3">{title}</Title>
      <Description variant="body3">{desc}</Description>
    </Root>
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  padding: ${rem(24)} ${rem(16)};
  border-radius: ${rem(10)};
  border: 1px solid ${props => getThemeColor('primary', props.theme)};
`

const Icon = styled(GatsbyImage)`
  margin: 0 auto;
  width: ${rem(50)};
`

const Title = styled(Typography)`
  display: flex;
  align-items: center;
  margin-top: ${rem(16)};

  &::before {
    content: '';
    flex-shrink: 0;
    display: block;
    margin-right: ${rem(16)};
    width: ${rem(4)};
    min-height: 2.6em;
    background-color: ${props => props.theme.primary.base};
  }
`

const Description = styled(Typography)`
  margin-top: ${rem(8)};
`
